import { render, staticRenderFns } from "./SASPartnerView.vue?vue&type=template&id=47c362d0&"
import script from "./SASPartnerView.vue?vue&type=script&lang=js&"
export * from "./SASPartnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports